import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=4a64116a"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"
import style0 from "./TokenList.vue?vue&type=style&index=0&id=4a64116a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports